import React from 'react';

const InviteUserModal = ({ 
  showInviteModal, 
  setShowInviteModal, 
  inviteForm, 
  setInviteForm, 
  inviteUser 
}) => {
  if (!showInviteModal) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-gray-900">Invite Team Member</h3>
          <button onClick={() => setShowInviteModal(false)} className="text-gray-400 hover:text-gray-600 text-2xl">×</button>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
            <input
              type="email"
              value={inviteForm.email}
              onChange={(e) => setInviteForm({...inviteForm, email: e.target.value})}
              placeholder="employee@company.com"
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
            <select
              value={inviteForm.role}
              onChange={(e) => setInviteForm({...inviteForm, role: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
            >
              <option value="employee">Employee - Participate in campaigns</option>
              <option value="view_only_admin">View-Only Admin - View dashboards</option>
              <option value="business_admin">Business Admin - Full access</option>
            </select>
          </div>
        </div>
        
        <div className="flex gap-3 mt-6">
          <button onClick={() => setShowInviteModal(false)} className="flex-1 py-3 border rounded-xl font-medium text-gray-600 hover:bg-gray-50">
            Cancel
          </button>
          <button onClick={inviteUser} className="flex-1 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700">
            Send Invitation
          </button>
        </div>
      </div>
    </div>
  );
};

export default InviteUserModal;
